import { filter, flatten, map, path, pathOr } from 'ramda';
import { filterIsNotEmpty, isEmptyOrNil, isNotEmpty } from 'src/utilities/hasValue';
import { API_RESOURCE_ASSETS, API_RESOURCE_BORROWERS, API_RESOURCE_BUSINESS, API_RESOURCE_COLLATERAL, API_RESOURCE_DECLARATIONS, API_RESOURCE_EMPLOYMENTS, API_RESOURCE_LENDING_TERMS, API_RESOURCE_LIABILITIES, API_RESOURCE_MONTHLY_INCOMES, API_RESOURCE_PROPERTIES, API_RESOURCE_USER_ACCOUNTS, API_RESOURCE_WORKFLOW_INTENTS, ApiResource } from '../constants';






const updateAccounts = (loanApp: any) => {
  const { account } = loanApp;
  return {
    kind: API_RESOURCE_USER_ACCOUNTS as ApiResource,
    payload: account

  }
}


const updateBorrowers = (loanApp: any) => {
  const { borrower } = loanApp;
  if (isEmptyOrNil(pathOr({}, ['profile'], borrower))) {
    return
  }
  return {
    kind: API_RESOURCE_BORROWERS as ApiResource,
    payload: borrower

  }
}


const updateLendingTerms = (loanApp: any) => {
  const { lendingTerms } = loanApp;
  if (isEmptyOrNil(pathOr({}, ['terms'], lendingTerms)) && isEmptyOrNil(pathOr({}, ['metadata'], lendingTerms))) {
    return
  }
  return {
    kind: API_RESOURCE_LENDING_TERMS as ApiResource,
    payload: lendingTerms

  }
}


const updateProperties = (loanApp: any) => {
  const { property } = loanApp;
  //TO-DO need to add resource name in loan products
  if (isNotEmpty(pathOr({}, ['address'], property)) || isNotEmpty(pathOr({}, ['object_meta'], property)) || isNotEmpty(pathOr({}, ['details'], property))) {
    return {
      kind: API_RESOURCE_PROPERTIES as ApiResource,
      payload: property

    }
  }
  return;
}


const updateCreditReports = (loanApp: any) => {
  const { liabilities } = loanApp;
  if (isNotEmpty(pathOr({}, ['metadata'], liabilities))) {
    return {
      kind: API_RESOURCE_LIABILITIES as ApiResource,
      payload: liabilities

    }
  }

  return;
}


const updateDeclaration = (loanApp: any) => {
  const { declaration } = loanApp;
  if (isEmptyOrNil(pathOr([], ['consents'], declaration))) {
    return
  }
  return {
    kind: API_RESOURCE_DECLARATIONS as ApiResource,
    payload: declaration

  }
}


const updateBusiness = (loanApp: any) => {
  const { business } = loanApp;
  return {
    kind: API_RESOURCE_BUSINESS as ApiResource,
    payload: business
  }
}

const createOrUpdateAssets = (assets: any) => {
  if (isEmptyOrNil(assets)) {
    return
  }
  return {
    kind: API_RESOURCE_ASSETS as ApiResource,
    payload: assets
  }

}


const createOrUpdateEmployments = (employments: any) => {

  if (isEmptyOrNil(employments)) {
    return
  }

  return {
    kind: API_RESOURCE_EMPLOYMENTS as ApiResource,
    payload: employments
  }
}


const createOrUpdateMonthlyIncomes = (monthlyIncomes: any) => {
  if (isEmptyOrNil(monthlyIncomes)) {
    return
  }
  return {
    kind: API_RESOURCE_MONTHLY_INCOMES as ApiResource,
    payload: monthlyIncomes
  }
}

const createOrUpdateCollateral = (collateral: any) => {
  if (isEmptyOrNil(collateral)) {
    return
  }
  return {
    kind: API_RESOURCE_COLLATERAL as ApiResource,
    payload: collateral
  }
}

const updateWorkflowIntent = (variables: any) => {
  const { data } = variables
  return {
    kind: API_RESOURCE_WORKFLOW_INTENTS as ApiResource,
    payload: data
  }
}


const apiResourceUpdateFns = {
  [API_RESOURCE_ASSETS]: updateAccounts,
  [API_RESOURCE_BORROWERS]: updateBorrowers, 
  [API_RESOURCE_BUSINESS]: updateBusiness,
  [API_RESOURCE_PROPERTIES]: updateProperties,
  [API_RESOURCE_LENDING_TERMS]: updateLendingTerms,
  [API_RESOURCE_LIABILITIES]: updateCreditReports,
  [API_RESOURCE_DECLARATIONS]: updateDeclaration
}

export const getLoanAppUpdateQuery = (
  specEntities: string[],
  resources: any
) => {
  const { loanApp, employments, monthlyIncomes, workflowIntent, assets, collaterals } = resources;
  const fns = filterIsNotEmpty(specEntities.map((apiResource: string) => path([apiResource], apiResourceUpdateFns)))

  return filter(
    isNotEmpty,
    flatten([
      map((fn: any) => fn && fn(loanApp), fns),
      createOrUpdateEmployments(employments),
      createOrUpdateCollateral(collaterals),
      createOrUpdateMonthlyIncomes(monthlyIncomes),
      createOrUpdateAssets(assets),
      updateWorkflowIntent(workflowIntent)
    ])
  )
}


